<div class="card p-4 flex flex-col mt-2">
  <nz-skeleton
    [ngClass]="loading() ? 'p-3' : 'p-0'"
    [nzLoading]="loading()"
    [nzActive]="true"
  >
    <div class="py-1 title flex gap-3 items-center">
      <button class="btn p-0" (click)="back()">
        <img
          src="https://storage.googleapis.com/komerce/assets/icons/back.svg"
          alt=""
          width="40px"
        />
      </button>
      <span> {{ isEditMode() ? 'Edit Team' : 'Add Team' }} </span>
    </div>
    <hr />
    <div class="mt-4">
      <span class="font-bold mb-3">Team Information</span>
      <form
        nz-form
        nzNoColon
        [formGroup]="addTeamForm"
        class="flex flex-col gap-3 mt-4 w-full lg:w-8/12"
      >
        <nz-form-item class="flex flex-col md:flex-row gap-2 mb-3">
          <nz-form-label nzRequired class="text-left w-full md:w-3/12 lg:w-4/12" nzFor="name"
            >Name</nz-form-label
          >
          <nz-form-control class="w-full flex-1" [nzValidateStatus]="validName() ? '' : 'error'">
            <nz-input-group nzSize="large">
              <input
                formControlName="username"
                nz-input
                placeholder="Name"
                type="text"
                (keypress)="setRegexName($event)"
                (input)="validateName()"
              />
            </nz-input-group>
            <span class="text-red-500 flex items-center gap-1 mt-1">
              <img
                *ngIf="errMessName() !== ''"
                src="https://storage.googleapis.com/komerce/assets/icons/danger-red.svg"
                alt="warning"
                style="max-width: 10px; max-height: 10px"
              />
              {{ errMessName() }}</span
            >
          </nz-form-control>
        </nz-form-item>

        <nz-form-item class="flex flex-col md:flex-row gap-2 mt-2 mb-3">
          <nz-form-label nzRequired class="text-left w-full md:w-3/12 lg:w-4/12" nzFor="email"
            >Email</nz-form-label
          >
          <nz-form-control class="w-full flex-1" [nzValidateStatus]="validEmail() ? '' : 'error'">
            <nz-input-group nzSize="large">
              <input
                formControlName="email"
                nz-input
                placeholder="Email"
                type="email"
                (keypress)="setRegex($event)"
                (keydown.enter)="$event.preventDefault()"
                (input)="validateEmail()"
              />
            </nz-input-group>
            <span class="text-red-500 flex items-center gap-1 mt-1">
              <img
                *ngIf="errMessEmail() !== ''"
                src="https://storage.googleapis.com/komerce/assets/icons/danger-red.svg"
                alt="warning"
                style="max-width: 10px; max-height: 10px"
              />
              {{ errMessEmail() }}</span
            >
          </nz-form-control>
        </nz-form-item>

        <nz-form-item class="flex flex-col md:flex-row gap-2 mt-2">
          <nz-form-label class="text-left w-full md:w-3/12 lg:w-4/12">Role</nz-form-label>
          <nz-form-control class="w-full flex-1" [nzSpan]="24" [nzErrorTip]="errorMes">
            <ng-select
              formControlName="role"
              [items]="roleList"
              bindLabel="name"
              bindValue="name"
              placeholder="Select Role"
            >
            </ng-select>
          </nz-form-control>
          <ng-template #errorMes>
            <span class="text-red-500 flex items-center gap-1 mt-1">
              <img
                src="https://storage.googleapis.com/komerce/assets/icons/danger-red.svg"
                alt="warning"
                style="max-width: 10px; max-height: 10px"
              />
              Please select your role!
            </span>
          </ng-template>
        </nz-form-item>

        <nz-form-item class="flex flex-col md:flex-row gap-2 mt-2 !mb-0">
          <nz-form-label nzRequired class="text-left w-full md:w-3/12 lg:w-4/12" nzFor="password"
            >Password</nz-form-label
          >
          <div class="flex flex-col w-full flex-1">
            <nz-input-group
              nzSize="large"
              [nzSuffix]="suffixTemplate"
              [nzStatus]="isValidPass() ? '' : 'error'"
            >
              <input
                nz-input
                nzSize="large"
                formControlName="password"
                minlength="6"
                maxlength="32"
                [type]="isShowPassword() ? 'text' : 'password'"
                placeholder="Enter Password"
                (keydown.enter)="$event.preventDefault()"
                (focus)="visibleValPass.set(true)"
                (blur)="visibleValPass.set(false)"
                (input)="validatePassword()"
                (keyup)="setRegexPassword($event)"
                nz-popover
                [nzPopoverContent]="contentPassTeam"
                nzPopoverPlacement="top"
                [nzPopoverVisible]="visibleValPass()"
                (nzPopoverVisibleChange)="visibleValPass.set($event)"
              />
            </nz-input-group>
            <span class="text-red-500 flex items-center gap-1 mt-1">
              <img
                *ngIf="errMessPass() !== ''"
                src="https://storage.googleapis.com/komerce/assets/icons/danger-red.svg"
                alt="warning"
                style="max-width: 10px; max-height: 10px"
              />
              {{ errMessPass() }}</span
            >
          </div>
            <ng-template #contentPassTeam>
              <div *ngFor="let data of validationPassword">
                <div
                  *ngIf="data.text"
                  :key="key"
                  class="flex items-start"
                >
                  <img
                    *ngIf="data.status"
                    src="https://storage.googleapis.com/komerce/assets/elements/Checkbox-on.svg"
                    alt="tick-success"
                  />
                  <img
                    *ngIf="!data.status"
                    src="https://storage.googleapis.com/komerce/assets/elements/Checkbox-off.svg"
                    alt="tick-success"
                  />
                  <div class="ml-1 text-sm">
                    {{ data.text }}
                  </div>
                </div>
              </div>
            </ng-template>
          <ng-template #suffixTemplate>
            <img
              [src]="isShowPassword() ? eyeOff : eyeOn"
              style="width: 20px !important; height: 20px"
              (click)="isShowPassword.set(!isShowPassword())"
              class="cursor-pointer"
            />
          </ng-template>
        </nz-form-item>

        <nz-form-item class="flex flex-col md:flex-row gap-2 mt-2">
          <nz-form-label nzRequired class="text-left w-full md:w-3/12 lg:w-4/12 whitespace-normal break-words" nzFor="confirmPassword"
            >Confirm Password</nz-form-label
          >
          <nz-form-control class="w-full flex-1">
            <nz-input-group
              nzSize="large"
              [nzSuffix]="suffixTemplate2"
              [nzStatus]="errMessPass2() === '' ? '' : 'error'"
            >
              <input
                nz-input
                nzSize="large"
                formControlName="confirmPassword"
                minlength="6"
                maxlength="32"
                [type]="isShowPassword2() ? 'text' : 'password'"
                placeholder="Enter Confirm Password"
                (keydown.enter)="$event.preventDefault()"
                (input)="confirmPassword()"
              />
            </nz-input-group>
            <span class="text-red-500 flex items-center gap-1 mt-1">
              <img
                *ngIf="errMessPass2() !== ''"
                src="https://storage.googleapis.com/komerce/assets/icons/danger-red.svg"
                alt="warning"
                style="max-width: 10px; max-height: 10px"
              />
              {{ errMessPass2() }}</span
            >
          </nz-form-control>
          <ng-template #suffixTemplate2>
            <img
              [src]="isShowPassword2() ? eyeOff : eyeOn"
              style="width: 20px !important; height: 20px"
              (click)="isShowPassword2.set(!isShowPassword2())"
              class="cursor-pointer"
            />
          </ng-template>
        </nz-form-item>

        <nz-form-item class="flex flex-col md:flex-row gap-2 mt-2">
          <nz-form-label nzRequired class="text-left w-full md:w-3/12 lg:w-4/12" nzFor="pin"
            >PIN</nz-form-label
          >
          <nz-form-control class="w-full flex-1">
            <nz-input-group
              nzSize="large"
              [nzSuffix]="suffixTemplatePIN"
              [nzStatus]="isValidPin() ? '' : 'error'"
            >
              <input
                nz-input
                nzSize="large"
                formControlName="pin"
                minlength="6"
                maxlength="6"
                [type]="visiblePin() ? 'number' : 'password'"
                placeholder="Enter 6 Digit PIN"
                (keydown.enter)="$event.preventDefault()"
                (blur)="visiblePin.set(false)"
                (keypress)="preventNonNumeric($event)"
                (input)="validateInputPin()"
              />
            </nz-input-group>
            <span class="text-red-500 flex items-center gap-1 mt-1">
              <img
                *ngIf="errMessPin() !== ''"
                src="https://storage.googleapis.com/komerce/assets/icons/danger-red.svg"
                alt="warning"
                style="max-width: 10px; max-height: 10px"
              />
              {{ errMessPin() }}</span
            >
          </nz-form-control>
          <ng-template #suffixTemplatePIN>
            <img
              [src]="visiblePin() ? eyeOff : eyeOn"
              style="width: 20px !important; height: 20px"
              (click)="visiblePin.set(!visiblePin())"
              class="cursor-pointer"
            />
          </ng-template>
        </nz-form-item>

        <nz-form-item class="flex flex-col md:flex-row gap-2 mt-2">
          <nz-form-label nzRequired class="text-left w-full md:w-3/12 lg:w-4/12 whitespace-normal break-words" nzFor="confirmPin"
            >Confirm PIN</nz-form-label
          >
          <nz-form-control class="w-full flex-1">
            <nz-input-group
              nzSize="large"
              [nzSuffix]="suffixTemplatePIN2"
              [nzStatus]="isValidPin2() ? '' : 'error'"
            >
              <input
                nz-input
                nzSize="large"
                formControlName="confirmPin"
                minlength="6"
                maxlength="6"
                [type]="visiblePin2() ? 'number' : 'password'"
                placeholder="Enter 6 Digit PIN"
                (keydown.enter)="$event.preventDefault()"
                (blur)="visiblePin2.set(false)"
                (keypress)="preventNonNumeric($event)"
                (input)="validateInputConfirmPin()"
              />
            </nz-input-group>
            <span class="text-red-500 flex items-center gap-1 mt-1">
              <img
                *ngIf="errMessPin2() !== ''"
                src="https://storage.googleapis.com/komerce/assets/icons/danger-red.svg"
                alt="warning"
                style="max-width: 10px; max-height: 10px"
              />
              {{ errMessPin2() }}</span
            >
          </nz-form-control>
          <ng-template #suffixTemplatePIN2>
            <img
              [src]="visiblePin2() ? eyeOff : eyeOn"
              style="width: 20px !important; height: 20px"
              (click)="visiblePin2.set(!visiblePin2())"
              class="cursor-pointer"
            />
          </ng-template>
        </nz-form-item>
      </form>
    </div>
  </nz-skeleton>
</div>

<div class="card p-4 d-flex flex-column mt-2">
  <nz-skeleton
    [ngClass]="loading() ? 'p-3' : 'p-0'"
    [nzLoading]="loading()"
    [nzActive]="true"
  >
    <form
      nz-form
      nzNoColon
      [formGroup]="addTeamForm"
      class="d-flex flex-column gap-3 mt-4 col-8"
    >
      <div class="d-flex gap-5">
        <span class="text-bold">Website Access</span>
        <label nz-checkbox [formControlName]="'allAccess'">
          <span>All Access</span>
        </label>
      </div>

      <div class="mt-3 px-4 d-flex">
        <div class="d-flex flex-column col-6" *ngFor="let col of menuStructure">
          <div
            class="d-flex flex-column gap-2"
            [class.mt-4]="!first"
            *ngFor="let group of col.groups; let first = first"
          >
            <span class="text-bold">{{ group.title }}</span>

            <ng-container *ngIf="!group.layout">
              <div *ngFor="let item of group.items">
                <label
                  nz-checkbox
                  [formControlName]="item.key"
                  [nzValue]="item.value"
                >
                  <span>{{ item.label }}</span>
                </label>
              </div>
            </ng-container>
            <div class="d-flex gap-5" *ngIf="group.layout === 'two-column'">
              <div
                class="d-flex flex-column"
                *ngFor="let subCol of group.columns"
              >
                <div *ngFor="let item of subCol">
                  <label
                    nz-checkbox
                    [formControlName]="item.key"
                    [nzValue]="item.value"
                  >
                    <span>{{ item.label }}</span>
                  </label>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </form>
  </nz-skeleton>
</div>
<div class="shadow-lg card p-4 d-flex flex-column mt-2" style="position: fixed; bottom: 0;"
  [ngStyle]="(isClosedSidebar() ? { width: '100%' } : { width: '80%' })"
>
  <nz-skeleton
    [ngClass]="loading() ? 'p-3' : 'p-0'"
    [nzLoading]="loading()"
    [nzActive]="true"
  >
    <div class="d-flex gap-2 justify-content-end">
  <button
    class="btn btn-outline-primary"
    style="width: 150px"
    (click)="resetData()"
  >
    Reset
  </button>

  <button
    class="btn me-5"
    [ngClass]="isFormInvalid ? 'btn-secondary' : 'btn-primary text-white'"
    style="width: 150px"
    [disabled]="isFormInvalid"
    (click)="saveTeam()"
  >
    Save
  </button>
</div>

  </nz-skeleton>
</div>

<app-modal-verif-email-team [isOpen]="isVerifTeam()"></app-modal-verif-email-team>
